<!--列表查看视图-->
<template>
  <el-dialog
    v-el-drag-dialog
    custom-class="bussiness-info-dialog"
    :visible.sync="innerVisible"
    :title="$t('SeaExport.AssociationBusinessInformation')"
    :close-on-click-modal="true"
    @close="innerVisible=false"
  >
    <div class="main-content">
      <div v-if="showRevokeButton" style="padding-bottom: 5px"><el-button no="revoke" type="danger" @click="revokeJobHandler">{{ $t('CargoMsg.Cargo_WithdrawTheEntrustment') }}</el-button></div>
      <div :class="'tabs-container' + (canOperateJob ? '' : ' cannot-operate-job')">
        <span class="lab-state">{{ labState }}</span>
        <el-tabs ref="tabs" v-model="activeTabName" type="card" @tab-click="handleTabClick">
          <!--海运出口-->
          <el-tab-pane v-if="!isRe && currentRow && !currentRow.masterFlag" :key="101" name="tabBookingFCL" :label="$t('SeaExport.Basic')">
            <tab-booking-fcl ref="tabBookingFCL" :slave-customs-declaration-enable="slaveCustomsDeclarationEnable" :context="context" :action="action" />
          </el-tab-pane>
          <!--主票不会被委托-->
          <!--<el-tab-pane v-if="currentRow && currentRow.masterFlag" :key="102" name="tabBookingMaster" label="基本">
          <tab-booking-master ref="tabBookingMaster" :context="context" :action="action"/>
          </el-tab-pane>-->
          <el-tab-pane v-if="!isRe" :key="103" name="tabVesselEq" :label="$t('SeaExport.Booking')">
            <tab-vessel-eq ref="tabVesselEq" :context="context" :action="action" :show-button="showButton" />
          </el-tab-pane>
          <el-tab-pane v-if="!isRe && !isCrossTenantSeToSi" :key="104" name="tabSpecialGoods" :label="$t('SpecialGoods.label')">
            <tab-special-goods ref="tabSpecialGoods" :context="context" :action="action" />
          </el-tab-pane>
          <el-tab-pane v-if="!isRe && !isCrossTenantSeToSi" :key="105" name="tabSopState" :label="$t('SeaExport.BusinessStatus')">
            <tab-sop-state v-if="$checkPermission(['tab_SEBooking_portalState'])" ref="tabSopState" :context="context" :action="action" :show-button="showButton" />
          </el-tab-pane>
          <el-tab-pane v-if="!isRe && !isCrossTenantSeToSi" :key="106" name="tabFileHistory" :label="$t('SeaExport.FileHistory')">
            <tab-file-history ref="tabFileHistory" :context="context" :action="action" :show-button="showButton" :can-operate-job="canOperateJob" view-source="trustFromWindow" />
          </el-tab-pane>
          <!--铁路出口 CARGO-31646 铁路模块新增「交叉委托」功能-->
          <el-tab-pane v-if="isRe && currentRow && !currentRow.masterFlag" :key="101" name="tabBookingFCLRe" :label="$t('SeaExport.Basic')">
            <tab-booking-fcl-re ref="tabBookingFCLRe" :context="context" :action="action" />
          </el-tab-pane>
          <el-tab-pane v-if="isRe && $checkPermission(['tab_REBooking_portalState'])" :key="105" name="tabSopStateRe" :label="$t('SeaExport.BusinessStatus')">
            <tab-sop-state ref="tabSopStateRe" :context="context" :action="action" :show-button="showButton" />
          </el-tab-pane>
          <el-tab-pane v-if="isRe" :key="106" name="tabFileHistoryRe" :label="$t('SeaExport.FileHistory')">
            <tab-file-history ref="tabFileHistoryRe" :context="context" :action="action" :show-button="showButton" :can-operate-job="canOperateJob" view-source="trustFromWindow" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import tabBookingFcl from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingFCL'
import tabBookingMaster from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingMaster'
import tabVesselEq from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabVesselEq'
import tabSpecialGoods from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabSpecialGoods'
import tabSopState from '@/components/Cargo/Job/booking/tabs/tabSopState'
import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory'
import tabBookingFclRe from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingFCL'
import { revokeJobFunc } from '@/api/booking/job'
import { cache, cacheName } from '@/utils/cacheManager'
import { SE } from '@/class/cargo/model/parameters/SystemConstants'
import { BB_CARGO_TYPE, BC_CARGO_TYPE, LCL_CARGO_TYPE } from '@/class/cargo/model/parameters/ContainerLoadType'

export default {
  name: 'TrustFromWindow',
  components: {
    tabBookingFcl,
    tabBookingMaster,
    tabVesselEq,
    tabSpecialGoods,
    tabSopState,
    tabFileHistory,
    tabBookingFclRe
  },
  props: {
    context: { type: Object, required: true },
    visible: { type: Boolean, required: true },
    isCrossTenantSeToSi: { type: Boolean, required: false },
    trustJob: { type: Object, required: false, default: null },
    job: { type: Object, required: false, default: null },
    canOperateJob: { type: Boolean, default: true }
  },
  data() {
    return {
      loading: false,
      showButton: false,
      innerVisible: false,
      action: 'look',
      currentRow: {},
      activeTabName: 'tabBookingFCL',
      labState: '',
      isJyd: false,
      showRevokeButton: false
    }
  },
  computed: {
    isRe() {
      return this.currentRow && this.currentRow.lob === 'RE'
    },
    config() {
      return this.context.config
    },
    seMultiSoMode() { // 海运出口开启拼箱小票多SO操作模式
      return this.config ? Number(this.config.get('SEMultiSoMode')) === 1 : false
    },
    slaveCustomsDeclarationEnable() { // 【小票】关单信息 是否可用
      return this.job.lob === SE.code && !this.job.masterFlag && this.seMultiSoMode && [LCL_CARGO_TYPE.code, BB_CARGO_TYPE.code, BC_CARGO_TYPE.code].indexOf(this.job.containerLoadType) >= 0
    }
  },
  watch: {
    async visible(newVal) {
      this.innerVisible = newVal
      // if (newVal) {
      //   this.$logger.log('trustJob', this.trustJob)
      //   await this.showDetail(this.trustJob, true)
      // }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    if (this.visible) {
      const loading = getLoading()
      this.context.loading = true
      this.innerVisible = true
      this.$logger.log('trustJob', this.trustJob)
      await cache.load(cacheName.CONFIG)
      await this.showDetail(this.trustJob, true)
      loading.close()
      this.context.loading = false
    }
  },
  methods: {
    async showDetail(trustJob, isRefresh) {
      this.currentRow = trustJob
      this.currentRow.path = ''
      this.labState = this.$t('SeaExport.BusinessStatus') + '：' + ColumnUtils.getJobStateCN(this.currentRow.jobState)
      this.activeTabName = this.currentRow.masterFlag ? 'tabBookingMaster' : 'tabBookingFCL'
      // 待审核中
      this.showRevokeButton = false
      if (this.currentRow.jobState === -1 && this.job && this.job.lob === this.currentRow.lob) {
        this.showRevokeButton = true
      }
      if (this.isRe) {
        this.activeTabName = 'tabBookingFCLRe'
      }
      // CARGO-46261 当参数“ToExoSystem”=JYD时委托逻辑调整
      this.isJyd = String(cache.config.get('ToExoSystem')) === 'JYD'
      if (this.isJyd && this.job.lob === this.currentRow.lob) {
        this.currentRow.userDefinedField1 = ''
        this.currentRow.userDefinedField2 = ''
        this.currentRow.userDefinedField3 = ''
        this.currentRow.userDefinedField4 = ''
      }
      this.handleTabClick()
    },
    revokeJobHandler() {
      if (this.job) {
        const loading = getLoading()
        const obj = {
          uuid: this.job.uuid
        }
        revokeJobFunc(obj).then(res => {
          if (res.data === 'ok') {
            this.$message.success(this.$t('CargoMsg.Cargo_RevokedSuccessfully'))
            this.innerVisible = false
            this.$emit('refresh')
          } else {
            this.$message.warning(this.$t('CargoMsg.Cargo_checkData1'))
          }
        }).finally(() => {
          loading.close()
        })
      }
    },
    handleTabClick() {
      this.$nextTick(() => {
        this.$refs[this.activeTabName].onShow(this.currentRow, true)
      })
    }
  }
}
</script>

<style lang="scss">
.el-dialog.bussiness-info-dialog {
  display: flex;
  height: 600px;
  width: 1415px;
  flex-direction: column;
  .el-dialog {
    &__body {
      position: relative;
      display: flex;
      overflow: hidden;
    }
  }
  &.isfullScreen {
    overflow: hidden;
  }
  .el-tabs {
    display: flex;
    flex-direction: column;
    width: 100%;
    &__content {
      overflow: scroll;
    }
  }
  .lab-state {
    position: absolute;
    z-index: 999;
    right: 30%;
  }
  .el-dialog__body {
    height: 100%;
  }
  .tabs-container.cannot-operate-job {
    .el-button {
      &.el-button--primary:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #8fbaea;
        border-color: #8fbaea;
      }
      &.el-button--success:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #a1dcc1;
        border-color: #a1dcc1;
      }
      &.el-button--danger:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #fab6b6;
        border-color: #fab6b6;
      }
    }
    .sop-img {
      pointer-events: none;
    }
  }
}
</style>
